module.exports = __webpack_public_path__ + "static/media/Sangría de Té de Jamaica y Jengibre.ecb0fd4b.webp";